import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'

import { autoLogin, logout } from 'redux/actions/user.actions'
import { checkJWTFormat } from 'helpers/util'
import App from './App'
import Login from '_pages/SitePages/Login'
import PageLoading from '_components/PageLoading'
import connectionStatus from '_components/ConnectionStatus'

connectionStatus()

export const Root = ({ isLoggedIn, autoLogin, logout }) => (
  <Switch>
    <Route
      exact
      path="/token-login/:jwt"
      render={props => {
        const { jwt } = props.match.params
        if (checkJWTFormat(jwt)) {
          autoLogin(jwt)
          return <PageLoading />
        } else {
          return <Redirect to="/" />
        }
      }}
    />
    <Route
      exact
      path="/logout"
      render={() => {
        logout()
        document.title = 'Log In - Ranktracker'
        return <Login />
      }}
    />
    {isLoggedIn ? (
      <Route
        exact
        path="/"
        render={() => {
          return <Redirect to="/dashboard" />
        }}
      />
    ) : (
      <Route exact path="/" render={() => {
        document.title = 'Log In - Ranktracker'
        return <Login />
      }} />
    )}
    <Route
      exact
      path="/login"
      render={() => {
        return <Redirect to="/" />
      }}
    />
    <Route path="/" component={App} />
  </Switch>
)

const mapStateToProps = state => {
  return {
    isLoggedIn: state.user?.isLoggedIn || false
  }
}
export default connect(mapStateToProps, {
  autoLogin,
  logout
})(Root)
